/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  work_id: z.number(),
  name: z.string(),
  affiliation: z.string(),
  role: z.string(),
  sort_order: z.number(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  name: base.shape.name.optional(),
  affiliation: base.shape.affiliation.optional(),
  role: base.shape.role.optional(),
  sort_order: base.shape.sort_order.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const WorkTechnicianBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type WorkTechnicianBase = z.infer<typeof base>;
export type WorkTechnicianBasePutPayload = z.infer<typeof put>;
export type WorkTechnicianBasePatchPayload = z.infer<typeof patch>;
export type WorkTechnicianBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type WorkTechnicianBaseCreateAttributes = z.infer<typeof create>;
export type WorkTechnicianBaseUpdateAttributes = z.infer<typeof update>;
export type WorkTechnicianBaseCacheAttributes = z.infer<typeof cache>;
export type WorkTechnicianBaseCachesAttributes = z.infer<typeof caches>;